import React from 'react';

export default class ReportIcon extends React.Component {

    render() {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="18"
            x="0"
            y="0"
            version="1.1"
            viewBox="0 0 70.002 83"
            xmlSpace="preserve"
          >
            <g transform="translate(-14.999 -8.5)">
              <path d="M81.001 19.5h-7v-7c0-2.2-1.8-4-4-4H18.999c-2.2 0-4 1.8-4 4v64c0 2.2 1.8 4 4 4h7v7c0 2.2 1.8 4 4 4h51c2.2 0 4-1.8 4-4l.002-64c0-2.2-1.8-4-4-4zm-62.002 58c-.542 0-1-.458-1-1v-64c0-.542.458-1 1-1h51.002c.542 0 1 .458 1 1v7H29.999c-2.2 0-4 1.8-4 4v54zm63 10c0 .542-.458 1-1 1h-51c-.542 0-1-.458-1-1v-64c0-.542.458-1 1-1h51.002c.542 0 1 .458 1 1z"></path>
              <path d="M41.001 46h29.998a1.5 1.5 0 000-3H41.001a1.5 1.5 0 100 3z"></path>
              <path d="M41.001 36h29.998a1.5 1.5 0 000-3H41.001a1.5 1.5 0 100 3z"></path>
              <path d="M41.001 56h29.998a1.5 1.5 0 000-3H41.001a1.5 1.5 0 100 3z"></path>
              <path d="M61.999 64a1.5 1.5 0 00-1.5 1.5v12a1.5 1.5 0 003 0v-12a1.5 1.5 0 00-1.5-1.5z"></path>
              <path d="M71.999 67a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 003 0v-9a1.5 1.5 0 00-1.5-1.5z"></path>
              <path d="M66.999 70a1.5 1.5 0 00-1.5 1.5v6a1.5 1.5 0 003 0v-6a1.5 1.5 0 00-1.5-1.5z"></path>
              <path d="M46.499 62a9 9 0 100 18 9 9 0 000-18zm-6 9a5.974 5.974 0 011.758-4.243A5.974 5.974 0 0146.499 65a5.974 5.974 0 014.242 1.757 5.976 5.976 0 011.756 4.196l-5.635-1.409a1.498 1.498 0 00-1.819 1.819l1.408 5.634a5.97 5.97 0 01-4.195-1.755A5.973 5.973 0 0140.499 71zm8.863 5.274l-.803-3.212 3.213.803a6.035 6.035 0 01-2.41 2.409z"></path>
            </g>
          </svg>
        )
    }

}
